(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caran-center-carousel"] && !Shopify.designMode) return;
  try {
    
  class CaranCenterCarousel extends HTMLElement {
    constructor() {
      super();

      this.currentIndex = 0;
      this.scrollTimeout = null;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      this.previousButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.indicators = Array.from(this.querySelectorAll('[data-carousel-indicator]'));

      if (!this.track || this.slides.length === 0) return;

      this.previousButton?.addEventListener('click', () => this.goToSlide(this.currentIndex - 1));
      this.nextButton?.addEventListener('click', () => this.goToSlide(this.currentIndex + 1));

      for (const [index, indicator] of this.indicators.entries()) {
        indicator.addEventListener('click', () => this.goToSlide(index));
      }

      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
      window.addEventListener('resize', () => this.updateActiveSlide());

      requestAnimationFrame(() => this.updateActiveSlide());
    }

    goToSlide(index) {
      const nextIndex = Math.min(Math.max(index, 0), this.slides.length - 1);
      const slide = this.slides[nextIndex];

      if (!slide) return;

      const left = slide.offsetLeft - (this.track.clientWidth - slide.clientWidth) / 2;

      this.track.scrollTo({
        left,
        behavior: 'smooth',
      });

      this.currentIndex = nextIndex;
      this.updateControls();
    }

    onScroll() {
      window.clearTimeout(this.scrollTimeout);
      this.scrollTimeout = window.setTimeout(() => this.updateActiveSlide(), 80);
    }

    updateActiveSlide() {
      const trackCenter = this.track.scrollLeft + this.track.clientWidth / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;

      for (const [index, slide] of this.slides.entries()) {
        const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
        const distance = Math.abs(trackCenter - slideCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      }

      this.currentIndex = closestIndex;
      this.updateControls();
    }

    updateControls() {
      const isFirst = this.currentIndex === 0;
      const isLast = this.currentIndex === this.slides.length - 1;

      this.previousButton?.setAttribute('aria-disabled', isFirst ? 'true' : 'false');
      this.nextButton?.setAttribute('aria-disabled', isLast ? 'true' : 'false');

      for (const [index, indicator] of this.indicators.entries()) {
        if (index === this.currentIndex) {
          indicator.setAttribute('aria-current', 'true');
        } else {
          indicator.removeAttribute('aria-current');
        }
      }
    }
  }

  if (!customElements.get('caran-center-carousel')) {
    customElements.define('caran-center-carousel', CaranCenterCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
